import BaseClass from "./BaseClass";

export default class SharedScripts extends BaseClass {
  constructor(data) {
    super(data);
    Object.keys(this.schema).forEach(v => {
      this[v] || this._set(this, v, undefined);
    });
  }

  static get schema() {
    return {
      uuid: { type: String },
      code: { type: String },
      uri: { type: String },
      params: { type: Object }
    };
  }

  initParams(params) {
    if (!params[this.code]) {
      return;
    }
    let parser = function(data) {
      if (data instanceof Array) {
        return data.reduce((r, v) => {
          r[v] = null;
          return r;
        }, {});
      }
      let tmp = {};
      if (data instanceof Object) {
        for (let key in data) {
          tmp[key] = parser(data[key]);
        }
      }
      return tmp;
    };

    this._set(
      this,
      "params",
      Object.assign({}, parser(params[this.code]), this.params)
    );
  }

  get embeddedString() {
    let tmp_params = {};
    for (let k in this.params) {
      Object.keys(this.params[k]).forEach(kk => {
        if (
          !this.params[k][kk] ||
          (this.params[k][kk] instanceof Array && !this.params[k][kk].length)
        ) {
          return;
        }
        tmp_params[k] || (tmp_params[k] = {});
        tmp_params[k][kk] = this.params[k][kk];
      });
    }
    let str = btoa(JSON.stringify(tmp_params)).replace(/=+$/, "");
    // let str = btoa(JSON.stringify(this.params)).replace(/=+$/, "");
    return `<script type="text/javascript" src="${this.uri}?${str}"></script>`;
  }

  save() {
    return this._api
      .query({
        query: require("../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\JStorage\\SPA\\JSSharedScripts",
          method: "saveScript",
          params: [this]
        }
      })
      .then(res => {
        Object.assign(this, res.data.opupet_query);
      });
  }

  delete() {
    return this._api
      .query({
        query: require("../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\JStorage\\SPA\\JSSharedScripts",
          method: "deleteScript",
          params: [this]
        }
      })
      .then(() => {
        return "deleted";
      });
  }
}
